import { GuestLayout } from "pages/Login/GuestLayout";

export const Login = () => {
	return <GuestLayout/>
}
